import { Button, Tooltip } from "@material-ui/core"
import AddLocationIcon from '@material-ui/icons/AddLocation';
import { useDispatch } from "react-redux";
import { openModalEscalasVuelo } from "../../../ducks/proveedorTerrestreDuck";

const BEscalasVuelos = (props) => {
    const { vuelo } = props
    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(openModalEscalasVuelo({
            vuelo
        }))
    }

    return(
        <Tooltip title="Escalas">
            <Button onClick={handleClick} color="primary" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <AddLocationIcon color="white" />
            </Button>
        </Tooltip>
    )
}

export default BEscalasVuelos;